import React from 'react';
import { FONT, TEXT3, WHITE } from '../../../shared';

// Google_Display_Ad — 300x250 medium-rectangle display banner
// Reference: Vella_Preview_Mockup_Spec.md (Google Display Network)
// Image fills · headline overlay · CTA button · "Ad · advertiser" badge
export default function GoogleDisplayAdChrome({
  assetUrl,
  headline = "Discover Your Brand",
  description = "Shop the new collection",
  ctaText = "Shop now",
  advertiser = "yourbrand.com",
  ctaColor = "#1A73E8",
}) {
  return (
    <div style={{ fontFamily: FONT, width: "100%", maxWidth: 300, position: "relative", borderRadius: 8, overflow: "hidden", border: "1px solid #DADCE0", background: "#FFFFFF", boxShadow: "0 1px 3px rgba(0,0,0,0.08)" }}>
      {/* 300x250 ad area — fixed 6:5 ratio */}
      <div style={{ width: "100%", aspectRatio: "300 / 250", position: "relative", background: "#0F172A", overflow: "hidden" }}>
        {assetUrl
          ? <img src={assetUrl} alt="ad" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          : <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: TEXT3, fontSize: 12, background: "linear-gradient(135deg,#1E293B,#0F172A)" }}>Asset loading…</div>}

        {/* Top-left "Ad · advertiser" badge */}
        <div style={{ position: "absolute", top: 6, left: 6, display: "flex", alignItems: "center", gap: 4, background: "rgba(255,255,255,0.92)", borderRadius: 3, padding: "2px 6px", fontSize: 10, lineHeight: 1.3, fontWeight: 500, color: "#202124" }}>
          <span style={{ color: "#0F9D58", fontWeight: 700 }}>Ad</span>
          <span style={{ opacity: 0.55 }}>·</span>
          <span style={{ opacity: 0.85 }}>{advertiser}</span>
        </div>

        {/* AdChoices icon */}
        <div style={{ position: "absolute", top: 6, right: 6, width: 14, height: 14, borderRadius: 2, background: "rgba(255,255,255,0.92)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, color: "#1A73E8", fontWeight: 700, lineHeight: 1 }}>
          ⓘ
        </div>

        {/* Bottom gradient + content overlay */}
        <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, padding: "32px 14px 12px", background: "linear-gradient(to top, rgba(0,0,0,0.78) 30%, rgba(0,0,0,0))", color: WHITE }}>
          <div style={{ fontSize: 16, fontWeight: 700, lineHeight: 1.25, marginBottom: 4, textShadow: "0 1px 2px rgba(0,0,0,0.4)" }}>{headline}</div>
          {description && (
            <div style={{ fontSize: 11, lineHeight: 1.35, opacity: 0.92, marginBottom: 10 }}>{description}</div>
          )}
          <button type="button" style={{ height: 30, padding: "0 14px", borderRadius: 4, background: ctaColor, color: WHITE, fontSize: 12, fontWeight: 600, border: 0, cursor: "pointer", boxShadow: "0 1px 2px rgba(0,0,0,0.18)" }}>
            {ctaText}
          </button>
        </div>
      </div>
    </div>
  );
}
